import(/* webpackMode: "eager", webpackExports: ["BlocksRenderer"] */ "/codebuild/output/src1214854546/src/client/node_modules/@strapi/blocks-react-renderer/dist/BlocksRenderer.mjs");
